import { useEffect, useState } from "react";
import { Card, Button, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from 'react-responsive';
import Box from "@mui/material/Box";

const config = require("../constants/constants.js")
const { strCurrency, strEuroCurrency } = require('../utils/currencyUtils.js')

const ProductForListComponent = ({ productId, name, description, price, images, rating, reviewsNumber }) => {

  const navigate = useNavigate();

  /*
  const imageDimensionStyle = { width: '300px', height: '300px' };

  function vedi (e) {
    e.preventDefault();
    window.location.assign("/product-details/"+productId) 
  }
                onClick={(e) => { vedi(e) }}               >

    <Card style={{ marginLeft: "0ch", marginTop: "30px", marginBottom: "50px" }}>

    style={{
      paddingLeft: 1,
      paddingRight: 1,
      paddingTop: 1,
      paddingBottom: 0,
     }}    
            style={imageDimensionStyle}

  */
          
  const isMobile = useMediaQuery({ query: '(min-width: 576px)' });
  const isTablet = useMediaQuery({ query: '(min-width: 768px)' });
  const isPC = useMediaQuery({ query: '(min-width: 992px)' });

  const url_dettagliservizio = "/product-details/"+productId;
  const url_image_dettagliservizio = config.URL_IMAGES_CUSTOMER1+"dettagli-servizio.png";  
  const help_image_dettagliservizio = "dettagli del servizio "+name;  


  let size_image_gotoPage=30;
  let imageDimensionStyle = { width: '300px', height: '300px' };
 
  if (isMobile===true) imageDimensionStyle='';
  if (isTablet===true) imageDimensionStyle='';
  if (isPC===true) imageDimensionStyle={ width: '300px', height: '300px' };
 
  useEffect(() => {
    console.log({isMobile});
    console.log({isTablet});
    console.log({isPC});
  },[isMobile])

  return (

    <Card body outline color="success" className="mx-2 my-3 px-0 py-0">

      <Box
        sx={{
          backgroundColor: '#ffffff',
          '&:hover': {
            backgroundColor: '#e9e9e9',
            opacity: [0.9, 0.8, 0.7],
          },
        }}
       >

      <Row>

        <Col lg={5}>

          <a href={url_dettagliservizio}>
            <Card.Img
                style={imageDimensionStyle}
                crossOrigin="anonymous"
                variant="top"
                src={images[0] ? images[0].path : ''}
              />
          </a>

        </Col>

        <Col lg={7}>

          <Card.Body
            style={{
              paddingLeft: 0,
              paddingRight: 0,
              paddingTop: 8,
              paddingBottom: 0,
            }}>
              
            <Card.Title>
              <Box
                fontSize="h6.fontSize"
                component="div" 
                overflow="hidden"            
                whiteSpace="pre-line"
                textOverflow="ellipsis"
                height={50}          
              >
                {name}
              </Box>
            </Card.Title>
           
            <Row>

              <Col md={9} class="text-start">
                {description}
              </Col>

              <Col md={3} class="text-end">

                <Box position="absolute" bottom="20px" right="20px">

                  <div 
                    onClick={event =>  {
                      event.preventDefault();
                      navigate(url_dettagliservizio)
                    }}
                  >
                    <img 
                      src={url_image_dettagliservizio} 
                      title={help_image_dettagliservizio}
                    />
                  </div>

                </Box>          


              </Col>

            </Row> 

          </Card.Body>

        </Col>

      </Row>

    </Box>

    </Card>
  );
};

export default ProductForListComponent;
